<template>
<v-app>
<v-main
    v-if="organization_account != null"
>

   <m-make-payment-app-bar
        :value="organization_label"
        :banner_branding="banner_branding"
    />

    <v-container
        style="display: flex;  justify-content: center;"
    >
        <div
            style="display: flex; max-width: 500px; gap: 25px; margin-top: 25px;"
        >
            <div
                style="width: 150px"
            >
                <v-icon
                    size="150"
                    style="margin-top: 55px;"
                >
                    mdi-link-variant
                </v-icon>
            </div>
            <div>
                <h2
                    style="margin-bottom: 15px"
                >
                    Link Expried
                </h2>
                
                <p>
                    The magic link you were sent has expired. 
                </p>
                <p>
                    You can obtain a new magic link by clicking the button below.  The new link will be sent to the cell phone number you have on file, ending x2281.
                </p>
                <div
                    style="text-align: left; margin-top: 25px"
                >
                    <a
                        v-on:click="onClickNewLink"
                        style="color: rgb(120,120,255); text-decoration: underline;"
                    >
                        Text Me A New Link...
                    </a>

                </div>
            </div>
        </div>
    </v-container>

</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>

export default {

    data() {
        return {
            banner_branding: null,
            organization_account: null,
        }
    },

    mounted () {
        this.loadProfile();
    },   

    methods: {
      loadProfile()
      {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/opt-in-form/default/profile',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'banner_id': this.$route.params.banner_id,
                    },
            
                'on_success': (data) => {
                        this.banner_branding = data.banner_branding;
                        this.organization_account = data.organization_account;
                    },
            
                'on_error': 'Unable to get form information',
            });
      },

      onClickNewLink()
      {
        this.$rc.showSpinner();
        window.setTimeout(() => this.afterLinkSent(), 1000);
      },

        afterLinkSent()
        {
            this.$rc.hideSpinner();
            this.$rc.alert('New link sent', 'A updated magic link has been sent to your cell phone ending x2281.');
        }
    },

    computed: {
        organization_label()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.label;
        },

        organization_id()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.organization_id;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>